(() => {
  'use strict';
  if (window.SneakStyleConversion) return;

  function deliveryDate(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(now);
    const values = Object.fromEntries(parts.filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
    const date = new Date(Date.UTC(values.year, values.month - 1, values.day + 8, 12));
    return {
      iso: date.toISOString().slice(0, 10),
      label: new Intl.DateTimeFormat('fr-FR', {
        timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long'
      }).format(date)
    };
  }

  function formatSize(value) {
    return String(value).replace(/(^|[\s/])(\d{1,2})[.,](\d+)(?=$|[\s/])/g, (_match, separator, integer, fraction) => {
      const decimal = fraction.replace(/0+$/, '');
      return separator + integer + (decimal ? ',' + decimal : '');
    }).replace(/^(\s*\d{1,2}(?:[.,]\d+)?)\s*\/\s*[a-z](?=\s*(?:—\s*Épuisé)?$)/i, '$1');
  }

  function footwearConfig(product) {
    const names = (product.options || []).map(option => typeof option === 'string' ? option : option.name);
    const pointure = names.findIndex(name => /^pointures?$/i.test(name));
    const footwear = !/chaussettes|socks/i.test(product.title || '') && (pointure >= 0 || /^(sneakers|chaussures?)$/i.test(product.type || ''));
    let index = pointure;
    if (index < 0) index = names.findIndex(name => /^(tailles?|sizes?)$/i.test(name));
    return {footwear, index: Math.max(0, index)};
  }

  function displayVariants(product, currentId) {
    const config = footwearConfig(product);
    const groups = new Map();
    (product.variants || []).forEach(variant => {
      const raw = (variant.options || [variant.option1, variant.option2, variant.option3])[config.index];
      const size = Number(String(raw).replace(',', '.'));
      if (config.footwear ? !Number.isInteger(size) || size < 36 || size > 47 : isFractionalSize(variant.title)) return;
      const key = formatSize(variant.title).trim();
      const previous = groups.get(key);
      if (!previous || variant.available && (!previous.available || String(variant.id) === String(currentId))) groups.set(key, variant);
    });
    const choices = [...groups.values()];
    if (config.footwear) choices.sort((a, b) => Number(String(a.options[config.index]).replace(',', '.')) - Number(String(b.options[config.index]).replace(',', '.')));
    return choices;
  }

  function updateDates() {
    if (!document.querySelector('[data-ss-delivery-date]')) return;
    const date = deliveryDate();
    document.querySelectorAll('[data-ss-delivery-date]').forEach(element => {
      if (element.textContent !== date.label) element.textContent = date.label;
      if (element.dateTime !== date.iso) element.dateTime = date.iso;
    });
  }

  function updateSizes() {
    const selectors = '[data-ssc-sticky-variant], .cart__item__selected-options span:last-child, #ss-cart-toast-text';
    document.querySelectorAll(selectors).forEach(element => {
      if (element.children.length) return;
      const current = element.textContent;
      const formatted = formatSize(current);
      if (formatted !== current) element.textContent = formatted;
    });
    document.querySelectorAll('select').forEach(select => {
      const label = select.labels && [...select.labels].map(element => element.textContent).join(' ');
      if (!select.matches('[data-ssc-variant-select], dialog[data-ss-quickview] select') && !/pointure|taille|size/i.test(label || select.getAttribute('aria-label') || '')) return;
      const previousValue = select.value;
      const groups = new Map();
      [...select.options].forEach(option => {
        if (isFractionalSize(option.textContent)) {option.remove(); return;}
        const formatted = formatSize(option.textContent);
        const key = formatted.replace(/\s*—\s*Épuisé\s*$/i, '').trim();
        const number = key.split('/').map(part => part.trim()).find(part => /^\d{1,2}(?:[.,]\d+)?$/.test(part));
        if (select.dataset.ssFootwear === 'true' && number && (Number(number.replace(',', '.')) < 36 || Number(number.replace(',', '.')) > 47)) {option.remove(); return;}
        if (formatted !== option.textContent) option.textContent = formatted;
        if (!number) return;
        const previous = groups.get(key);
        if (!previous) {groups.set(key, option); return;}
        if (!option.disabled && (previous.disabled || option.value === previousValue)) {
          previous.remove();
          groups.set(key, option);
        } else option.remove();
      });
      if (select.dataset.ssFootwear === 'true') {
        const options = [...select.options];
        const ordered = [...options].sort((a, b) => parseFloat(a.textContent.match(/\d{1,2}(?:[.,]\d+)?/)?.[0]) - parseFloat(b.textContent.match(/\d{1,2}(?:[.,]\d+)?/)?.[0]));
        if (ordered.some((option, index) => option !== options[index])) select.replaceChildren(...ordered);
      }
      if (select.value !== previousValue) {
        const available = [...select.options].find(option => !option.disabled);
        if (available) select.value = available.value;
        select.dispatchEvent(new Event('change', {bubbles: true}));
      }
    });
    document.querySelectorAll('dialog[data-ss-quickview] button').forEach(button => {
      const label = button.textContent.trim();
      if (isFractionalSize(label)) {button.hidden = true; button.disabled = true; return;}
      if (button.children.length || !/^\d{1,2}(?:[.,]0+)?$/.test(label)) return;
      const formatted = formatSize(label);
      if (label !== formatted) button.textContent = formatted;
    });
  }

  function isFractionalSize(value) {
    const match = String(value).split('/').map(part => part.trim()).map(part => part.match(/^\d{1,2}[.,](\d+)(?:\s|$)/)).find(Boolean);
    return !!match && /[1-9]/.test(match[1]);
  }

  function update() {
    updateDates();
    updateSizes();
  }

  let scheduled = false;
  const watched = '[data-ss-delivery-date], [data-ssc-sticky-variant], .cart__item__selected-options, #ss-cart-toast-text, select, dialog[data-ss-quickview]';
  const observer = new MutationObserver(records => {
    if (scheduled || !records.some(record => record.target.nodeType === 1 && record.target.closest(watched) || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches(watched) || node.querySelector(watched))))) return;
    scheduled = true;
    requestAnimationFrame(() => {scheduled = false; update();});
  });

  window.SneakStyleConversion = {deliveryDate, formatSize, isFractionalSize, displayVariants, footwearConfig};
  update();
  observer.observe(document.body, {childList: true, subtree: true});
  document.addEventListener('change', update);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('sneakstyle:cart:realtime-sync', update);
  document.addEventListener('visibilitychange', () => {if (!document.hidden) update();});
  window.addEventListener('pageshow', update);
  window.setInterval(() => {if (!document.hidden) updateDates();}, 60000);
})();
